module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "w"
  }, [_c('a', {
    class: {
      active: _vm.sortType === 1
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("综合排序")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.sortType === 2
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.sortByPrice(1)
      }
    }
  }, [_vm._v("价格从低到高")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.sortType === 3
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.sortByPrice(-1)
      }
    }
  }, [_vm._v("价格从高到低")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "35vw"
    },
    attrs: {
      "element-loading-text": "加载中..."
    }
  }, [(!_vm.noResult) ? _c('div', {
    staticClass: "img-item"
  }, [_c('div', {
    staticClass: "goods-box w"
  }, _vm._l((_vm.goods), function(item, i) {
    return _c('mall-goods', {
      key: i,
      attrs: {
        "msg": item
      }
    })
  }), 1), _vm._v(" "), (!_vm.noResult && !_vm.error) ? _c('el-pagination', {
    attrs: {
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.goodsTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.noResult) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/no-search.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 抱歉！暂时还没有商品\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/error.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 抱歉！出错了...\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b579d5f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/goods/index.vue
// module id = 771
// module chunks = 2